import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { MineResponse } from './mine-response';
import { MinesQuery } from './mines-query';
import { PagedResult } from '../devices/paged-result';

@Injectable({
  providedIn: 'root',
})
export class MinesHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE) private readonly apiBase: string
  ) {}

  search(query: MinesQuery): Observable<PagedResult<MineResponse>> {
    let params = new HttpParams();

    if (query.id) {
      params = params.set('id', query.id);
    }
    if (query.name) {
      params = params.set('name', query.name);
    }
    if (query.controllerName) {
      params = params.set('controllerName', query.controllerName);
    }
    if (query.operatorName) {
      params = params.set('operatorName', query.operatorName);
    }
    if (query.businessName) {
      params = params.set('businessName', query.businessName);
    }
    if (query.primarySicCode) {
      params = params.set('primarySicCode', query.primarySicCode);
    }
    if (query.state) {
      params = params.set('state', query.state);
    }
    if (query.pageNumber) {
      params = params.set('pageNumber', query.pageNumber.toString());
    }
    if (query.pageSize) {
      params = params.set('pageSize', query.pageSize.toString());
    }
    if (query.sortBy) {
      params = params.set('sortBy', query.sortBy);
    }
    if (query.sortDescending !== undefined) {
      params = params.set('sortDescending', query.sortDescending.toString());
    }

    return this.httpClient.get<PagedResult<MineResponse>>(`${this.apiBase}/mines`, { params });
  }

  getById(id: string): Observable<MineResponse> {
    return this.httpClient.get<MineResponse>(`${this.apiBase}/mines/${id}`);
  }

  update(id: string, mine: Partial<MineResponse>): Observable<MineResponse> {
    return this.httpClient.put<MineResponse>(`${this.apiBase}/mines/${id}`, mine);
  }
}